import React, { useContext, useState, useRef, useEffect } from 'react';
import styles from './style.module.scss';
import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Radio,
    RadioGroup,
    FormControlLabel,
    TextField,
    Grid
} from '@material-ui/core';
import { NewOrderHeader, cancelledHeader, shippedAndDeliveredHeader, pendingRTSHeader, PageItems, RTSHeader } from './constant';
import { OverlayTrigger, Popover } from "react-bootstrap";
import { Context as AuthContext } from '../../context/AuthContext';
import EditIcon from '@material-ui/icons/Edit';
import GetAppIcon from '@material-ui/icons/GetApp';

import { convertDate, capitalizeOnlyFirstLetter } from "../../utils/commonFunctions";
import { makeStyles } from "@material-ui/core/styles";
import { ProductLoader } from '../../components/Loader/skeletonLoader';
import { getShippingLabel } from './indexApi';
import AlertComponent from '../../components/AlertComponent';

const OrderTable = (props) => {
    const { state } = useContext(AuthContext);
    const loginData = state.userData;
    const rejectRef = useRef();
    const invoiceRef = useRef();
    const invoiceRegenRef = useRef();
    const [idx, setIndex] = useState(null);
    const [rejectValue, setRejectValue] = useState();
    const [showRejModal, setShowRejModal] = useState(false);
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    const [showReGenInvoiceModal, setShowReGenInvoiceModal] = useState(false);
    const [deliveryModeSelections, setDeliveryModeSelections] = useState({});
    const usestyles = makeStyles({
        radio: {
            '&$checked': {
                color: '#389203'
            }
        },
        checked: {}
    });
    const classes = usestyles();
    const [serialNumber, setSerialNumber] = useState(null);
    const [invoiceLoading, setInvoiceLoading] = useState(false);
    const [regenLoading, setRegenLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertObj, setAlertObj] = useState({});

    const downloadShippingLabel = async (orderId, shipmentId) => {
      const { data: labelData } = await getShippingLabel({
        orderId,
        shipmentId,
      });
      if (labelData?.data?.link) {
        window.open(labelData?.data?.link, "_blank");
      } else {
        setAlertObj({
          msg: labelData?.msg || "An unknown error occurred!",
          color: "#f44336",
        });
        setShowAlert(true);
      }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, []);

    //function to handle modle click
    const handleClick = e => {
        if (rejectRef && rejectRef.current && (!rejectRef.current.contains(e.target))) {
            setShowRejModal(false);
            setRejectValue(null);
        }
        if (invoiceRef && invoiceRef.current && (!invoiceRef.current.contains(e.target))) {
            setShowInvoiceModal(false);
            setSerialNumber(null);
        }
    };

    //function to cancel modal
    const cancelModal = (type) => {
        if (type === 'reject') {
            setShowRejModal(false);
            setRejectValue(null);
        } else if (type === 'reInvoice') {
            setShowReGenInvoiceModal(false);
            setSerialNumber(null);
        }
        else {
            setShowInvoiceModal(false);
            setSerialNumber(null);
        }

    }

    const getTableHeader = () => {
        if (props.status === 'NEW_ORDERS') {
            if(loginData?.seller_id === 24346){
                return NewOrderHeader.filter(item => item.id !== "action")
            }
            return NewOrderHeader;
        }
        else if (props.status === 'PENDING_RTS') {
            return pendingRTSHeader;
        }
        else if (props.status === 'READY_TO_SHIP') {
            return RTSHeader;
        }
        else if (props.status === 'DELIVERED') {
            if (!loginData?.isSelfDelivery) {
                return shippedAndDeliveredHeader.filter(item => item.id !== 'selfDeliveryAction');
            }
            return shippedAndDeliveredHeader;
        }
        else if (props.status === 'CANCELLED') {
            return cancelledHeader;
        }
    }

    const tableHeader = getTableHeader();

    //function to fetch status class
    const getStyleClass = (status) => {
        let statusClass;
        if (status === 'PENDING')
            statusClass = "pendingStatus";
        else if (status === 'APPROVED')
            statusClass = "approvedStatus";
        else if (status === 'SHIPPED')
            statusClass = "shippedStatus";
        else if (status === 'DELIVERED')
            statusClass = "deliveredStatus";
        else if (status === 'CANCELLED')
            statusClass = "cancelledStatus";

        return statusClass;
    }

    //function to handle reject value
    const handleChange = (e) => {
        setRejectValue(e.target.value)
    }

    // function to handle delivery mode dropdown change per order
    const handleDeliveryModeChange = (orderId, value) => {
        setDeliveryModeSelections(prev => ({
            ...prev,
            [orderId]: value
        }));
    };

    //function to fetch invoice path
    const invoicePdfUrl = () => {
        if (
            window.location.href.indexOf("test") > -1 ||
            window.location.href.indexOf("localhost") > -1
        ) {
            return "http://homeyantra-test-static.s3.ap-south-1.amazonaws.com/images/sales_invoice/";
        }
        return "https://homeyantra-static.s3.us-west-2.amazonaws.com/images/sales_invoice/";
    };

    //function to fetch table row data
    const getRowData = (column, value, item, index) => {
        if (column === 'currentStatus') {
            return <span >{value}</span>;
        }
        else if (column === 'action') {
            return <div className="row d-flex align-items-center justify-content-center">
                <Button variant="contained" className={`${styles.approveBtn}`} disableElevation onClick={() => props.acceptOrder(item)}>
                    Accept
                </Button>
                <div ref={rejectRef} className="d-flex align-items-center justify-content-center"  >
                    <OverlayTrigger container={rejectRef} trigger="click" placement="bottom" show={showRejModal && idx === index} overlay={
                        <Popover id="popover-basic">
                            <Popover.Content style={{ paddingTop: '0.8rem', paddingBottom: '0.8rem' }}>
                                <div>
                                    <RadioGroup aria-label="reject" name="reject" value={rejectValue || null} onChange={(e) => handleChange(e)}>
                                        <FormControlLabel value="OUT OF STOCK" control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />} label="Out of stock" />
                                        <FormControlLabel value="PRICE ISSUE" control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />} label="Price issue" />
                                    </RadioGroup>
                                    <div className="d-flex mt-3 justify-content-between">
                                        <Button variant="contained" color="primary" disabled={!rejectValue} onClick={() => { props.rejectOrder(item, rejectValue); cancelModal('reject') }}>
                                            Submit
                                        </Button>
                                        <Button variant="contained" style={{ background: 'white', color: 'grey', outline: 'none' }} disableElevation onClick={() => cancelModal('reject')}>
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                            </Popover.Content>
                        </Popover>
                    } >
                        <div className="d-flex align-items-center">
                            <Button variant="contained" className={`${styles.rejectBtn} ml-2`} disableElevation onClick={() => { setShowRejModal(true); setIndex(index) }}>
                                Reject
                            </Button>
                        </div>

                    </OverlayTrigger>
                </div>

            </div>
        }
        else if (column === 'invoice') {
            const isPostShip = props.status === 'DELIVERED' || props.status === 'CANCELLED';

            if (isPostShip) {
                return item.invoicePdf
                    ? <a href={item.invoicePdf} target="_blank" download={true} style={{ color: '#3a9206' }} rel="noreferrer">{item.invoiceNo}</a>
                    : null;
            }

            return (!item.invoicePdf ?
                <div className="d-flex flex-column align-items-center justify-content-center">
                    {loginData?.isSelfDelivery ? (
                        <div className="mb-2" style={{ width: '100%' }}>
                            <select
                                className={styles.selectPadding}
                                value={deliveryModeSelections[item.orderId] || ""}
                                onChange={(e) => handleDeliveryModeChange(item.orderId, e.target.value)}
                            >
                                <option value="" disabled>Select Mode</option>
                                <option value="3PL">3PL</option>
                                <option value="SELF">SELF</option>
                            </select>
                        </div>
                    ) : null}
                    {(loginData?.isSelfDelivery ? !!deliveryModeSelections[item.orderId] : true) && (
                        <div ref={invoiceRef} className="d-flex align-items-center justify-content-center"  >
                            <OverlayTrigger container={invoiceRef} trigger="click" placement="bottom" show={showInvoiceModal && idx === index} overlay={
                                <Popover id="popover-basic">
                                    <Popover.Content style={{ paddingTop: '0.8rem', paddingBottom: '0.8rem' }}>
                                        <div>
                                            <form noValidate autoComplete="off">
                                                <TextField id="standard-basic" value={serialNumber} autoFocus label={'Enter Serial Number'} onChange={(e) => { setSerialNumber(e.target.value) }} />
                                            </form>
                                            <div className="d-flex mt-3 justify-content-between">
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    disabled={!serialNumber || invoiceLoading}
                                                    onClick={async () => {
                                                        setInvoiceLoading(true);
                                                        await props.generateInvoice(
                                                            item,
                                                            serialNumber,
                                                            loginData?.isSelfDelivery ? deliveryModeSelections[item.orderId] : '3PL'
                                                        );
                                                        setInvoiceLoading(false);
                                                        cancelModal('invoice');
                                                    }}
                                                >
                                                    {invoiceLoading ? 'Generating...' : 'Generate'}
                                                </Button>
                                                <Button variant="contained" style={{ background: 'white', color: 'grey', outline: 'none' }} disableElevation onClick={() => cancelModal('invoice')}>
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </Popover.Content>
                                </Popover>
                            } >
                                <div className="d-flex align-items-center">
                                    <Button variant="outlined" color="primary" disableElevation style={{ fontSize: '0.875rem' }} onClick={() => { setShowInvoiceModal(true); setIndex(index) }}>Generate Invoice</Button>
                                </div>

                            </OverlayTrigger>
                        </div>
                    )}
                </div>

                : <>
                    <a href={item.invoicePdf} target="_blank" download={true} style={{ color: '#3a9206' }} rel="noreferrer">{item.invoiceNo}</a>
                    <div ref={invoiceRegenRef} className="d-flex align-items-center justify-content-center"  >
                        <OverlayTrigger container={invoiceRegenRef} trigger="click" placement="bottom" show={showReGenInvoiceModal && idx === index} overlay={
                            <Popover id="popover-basic">
                                <Popover.Content style={{ paddingTop: '0.8rem', paddingBottom: '0.8rem' }}>
                                    <div>
                                        <form noValidate autoComplete="off">
                                            <TextField id="standard-basic" value={serialNumber} autoFocus label={'Enter Serial Number'} onChange={(e) => { setSerialNumber(e.target.value) }} />
                                        </form>
                                        <div className="d-flex mt-3 justify-content-between">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={!serialNumber || regenLoading}
                                                onClick={async () => {
                                                    setRegenLoading(true);
                                                    await props.reGenerateInvoice(item, serialNumber);
                                                    setRegenLoading(false);
                                                    cancelModal('reInvoice');
                                                }}
                                            >
                                                {regenLoading ? 'Regenerating...' : 'Regenerate'}
                                            </Button>
                                            <Button variant="contained" style={{ background: 'white', color: 'grey', outline: 'none' }} disableElevation onClick={() => cancelModal('reInvoice')}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                </Popover.Content>
                            </Popover>
                        } >
                            <div className="d-flex align-items-center">
                                <Button variant="outlined" color="primary" disableElevation style={{ fontSize: '0.875rem' }} onClick={() => { setShowReGenInvoiceModal(true); setIndex(index) }}>Regenerate</Button>
                            </div>

                        </OverlayTrigger>
                    </div>
                </>

            )
        }
        else if (column === 'shippingLabels') {
            return (
                
                <Button onClick={e=> downloadShippingLabel(item.orderId, item.shipmentId)}  style = {{color:'#3a9206'}} variant="info">Download</Button>
            
            )
        }
        else if (column === 'trackingId') {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center">
                    {value && <span>{value}</span>}
                    {item.deliveryType === 'SELF' && (
                        <span style={{
                            display: 'inline-block',
                            marginTop: value ? 4 : 0,
                            padding: '2px 10px',
                            fontSize: '0.75rem',
                            fontWeight: 600,
                            color: '#fff',
                            backgroundColor: '#389203',
                            borderRadius: '4px'
                        }}>SELF</span>
                    )}
                </div>
            );
        }
        else if (column === 'selfDeliveryAction') {
            if (item.deliveryType !== 'SELF') {
                return <span style={{ color: '#999' }}>—</span>;
            }
            const actionStatus = item.actionStatus;
            return (
                <div className="d-flex flex-column align-items-center" style={{ gap: 6 }}>
                    {actionStatus !== 'OUT_FOR_DELIVERY' && actionStatus !== 'DELIVERED' && (
                        <Button
                            variant="contained"
                            disableElevation
                            style={{
                                fontSize: '0.75rem',
                                backgroundColor: '#ff9800',
                                color: '#fff',
                                textTransform: 'none',
                                whiteSpace: 'nowrap'
                            }}
                            onClick={() => props.updateSelfDeliveryStatus(item, 'OUT_FOR_DELIVERY')}
                        >
                            Out for Delivery
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        disableElevation
                        style={{
                            fontSize: '0.75rem',
                            backgroundColor: actionStatus === 'DELIVERED' ? '#ccc' : '#389203',
                            color: '#fff',
                            textTransform: 'none'
                        }}
                        disabled={actionStatus === 'DELIVERED'}
                        onClick={() => props.updateSelfDeliveryStatus(item, 'DELIVERED')}
                    >
                       Mark as Delivered
                    </Button>
                </div>
            );
        }
        else if (column === 'pickupSlot') {
            return (<div className={styles.iconContainer}>
                {value}
                <EditIcon className={styles.editIcon} onClick={() => props.edit()} />
            </div>)
        }
        else if (column === 'actionRts') {
            return <Button variant="contained" color="primary" disableElevation style={{ fontSize: '0.875rem' }} disabled={!item.invoicePdf} onClick={() => props.readyToShipFnc(item)}>Ready to ship</Button>
        }
        else if (column === 'category') {
            return value ? capitalizeOnlyFirstLetter(value) : value;
        }
        else {
            return value;
        }
    }

    return <React.Fragment>
        <div className={styles.orderWrapper}>
            {
                props.copySelectedFilters.category && props.copySelectedFilters.category.map((item, index) => {
                    return <Chip
                        key={item + index}
                        label={item}
                        onDelete={() => props.handleDelete(item, 'category')}
                        className={`mb-1 mr-1 ${styles.chip}`}
                    />
                })
            }
            {
                props.copySelectedFilters.brand && props.copySelectedFilters.brand.map((item, index) => {
                    return <Chip
                        key={item + index}
                        label={item}
                        onDelete={() => props.handleDelete(item, 'brand')}
                        className={`mb-1 mr-1 ${styles.chip}`}
                    />
                })
            }
        </div>
        <div className={styles.tableConatiner}>
            {
                props.pageLoader ?
                    <Paper className={styles.loaderWrapper}>
                        <div id={styles.headerLoader}>
                        </div>
                        <div className="pl-4 pr-4">
                            <ProductLoader />
                        </div>
                    </Paper>
                    :
                    <Paper>
                        <TableContainer className={styles.parentWrapper}>
                            <Table stickyHeader aria-label="sticky table" >
                                <TableHead>
                                    <TableRow >
                                        {tableHeader.map((column, index) => (
                                            <TableCell
                                                className={styles.tableBorder}
                                                key={index}
                                                align={column.align}
                                                style={{ minWidth: column.minWidth }}
                                            >
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody >
                                    {props.orderData && props.orderData.length > 0 && props.orderData.map((order, index) => {
                                        return (
                                            <TableRow hover key={index}>
                                                {tableHeader.map((header) => {
                                                    const value = order[header.id];
                                                    return (
                                                        <TableCell key={header.id} align={header.align} className={styles.tableBorder}>
                                                            {getRowData(header.id, value, order, index)}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                                    {props.orderData && props.orderData.length === 0 &&
                                        <tr>
                                            <td colSpan="7">
                                                <div className="d-flex justify-content-center p-5 text-muted" style={{fontSize:'0.875rem'}}>
                                                    {props.status === 'NEW_ORDERS' ?
                                                         "Currently there are no active orders for you. We'll notify you once we assign you an order."
                                                       : 'No orders to display'}  
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </TableBody>
                            </Table>

                        </TableContainer>
                        <div className="pl-3 pr-3 p-2">
                                <Grid container justify='space-between' >
                                    <Grid item>
                                        <div className="text-muted">
                                            Showing {props.reqObj.page === 1 ? props.reqObj.page : props.reqObj.size * (props.reqObj.page - 1)} -
                                            {props.reqObj.page === 1 ? props.reqObj.size : (props.orderData && props.orderData.length) === props.reqObj.size ? props.reqObj.size * props.reqObj.page : ((props.reqObj.size * props.reqObj.page) - (props.reqObj.size - props.orderData.length))} of {props.orderData.length} entries
                                            <span className={styles.divider}></span>
                                            <span>
                                                Rows per page
                                                <select
                                                    className={styles.selectPadding}
                                                    value={props.reqObj.size}
                                                    onChange={(e) => props.setItemsPerPage(e.target.value)}>
                                                    {
                                                        PageItems.map((page, index) => {
                                                            return <option key={index} value={page}>{page}</option>
                                                        })
                                                    }
                                                </select>
                                            </span>
                                        </div>
                                    </Grid>
                                    <Grid item alignItems='center'>
                                        <div className="">
                                            <nav aria-label="..." style={{ top: 10 }}>
                                                <ul className="pagination mb-0">
                                                    <li onClick={() => props.reqObj.page > 1 && props.totalPageCount != 0 ? props.handlePageChange('prev') : null} className={`page-item ${props.reqObj.page === 1 || props.totalPageCount === 0 ? "disabled" : null} `}>
                                                        <button className={`${props.reqObj.page === 1 || props.totalPageCount === 0 ? styles.disablePage : null} page-link ${styles.pageLink}`} tabIndex="-1">
                                                            Previous
                                                        </button>
                                                    </li>
                                                    <li>
                                                        <button className={`page-link ${styles.page}`} style={{ pointerEvents: 'none' }}>
                                                            {props.reqObj.page}
                                                        </button>
                                                    </li>
                                                    <li onClick={() => props.totalPageCount != props.reqObj.page && props.totalPageCount != 0 ? props.handlePageChange('Next') : ''} className={`page-item ${props.totalPageCount == props.reqObj.page || props.totalPageCount === 0 ? "disabled" : null} `}>
                                                        <button className={`${props.totalPageCount == props.reqObj.page || props.totalPageCount === 0 ? styles.disablePage : null} page-link ${styles.pageLink}`} >
                                                            Next
                                                        </button>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </Grid>
                                </Grid>
                        </div>
                    </Paper>
            }
        </div>
        <AlertComponent color={alertObj.color} msg={alertObj.msg} open={showAlert} handleClose={() => setShowAlert(false)} />
    </React.Fragment>
}

export default OrderTable;